<a href="#">
  <svg kebab-horizontal-icon size="small"></svg>
</a>
